// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1__Tz","cls2":"CreateSocialItemModal-cls2_IlK CreateSocialItemModal-cls1__Tz"};